import React from "react";
import { Link } from "react-router-dom";

import logoFull from "../assets/brand/logo-full.png";
import logoLight from "../assets/brand/logo-light.png";
import { APP_NAME, APP_TAGLINE } from "../config/brand";

/**
 * The client's logo. The supplied artwork has black wordmark text, so the
 * `light` variant (white text, same coloured swirl) is used wherever the logo
 * sits on the dark navy footer or hero.
 */
export default function Logo({ light = false, withTagline = true }) {
  return (
    <Link to="/" className="inline-flex items-center gap-2.5">
      <img
        src={light ? logoLight : logoFull}
        alt={APP_NAME}
        className="h-12 w-auto object-contain sm:h-14"
      />
      {withTagline && (
        <span
          className={`hidden text-[10px] font-medium leading-tight sm:block ${
            light ? "text-slate-400" : "text-slate-500"
          }`}
        >
          {APP_TAGLINE}
        </span>
      )}
    </Link>
  );
}
